import Login3Container from "../../../components/pages/other/Login3";

const Login3 = () => {
  return <Login3Container />;
};

export default Login3;
